/**
 * Labstep
 *
 * @module grid/services/grid-export
 * @desc CSV/Excel export business logic
 */

import type { ProcessCellForExportParams } from 'ag-grid-community';

export class GridExportService {
  public static processCellCallback(
    params: ProcessCellForExportParams,
  ) {
    const colDef = params.column.getColDef();
    if (colDef) {
      const { valueGetterExport } = colDef as any;
      if (
        valueGetterExport &&
        typeof valueGetterExport === 'function'
      ) {
        return valueGetterExport(params);
      }

      if (params.value) {
        return params.value;
      }
    }
    return '';
  }

  public static defaultCsvExportParams = {
    processCellCallback: GridExportService.processCellCallback,
  };

  public static defaultExcelExportParams = {
    processCellCallback: GridExportService.processCellCallback,
  };
}
